export default "__VITE_PUBLIC_ASSET__e4018567__"